import { render, staticRenderFns } from "./Hours_statistics.vue?vue&type=template&id=638f74ca"
import script from "./Hours_statistics.vue?vue&type=script&lang=js"
export * from "./Hours_statistics.vue?vue&type=script&lang=js"
import style0 from "./Hours_statistics.vue?vue&type=style&index=0&id=638f74ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports